import {
  TComponentValue,
} from '@/types/openapi-type.ts';

const details: Record<TComponentValue<'QmulusLicenseViolationReason'>, string> = {
  NO_LICENSE_KEY: 'To continue using Qmulus, a valid license key must be provided.',
  ASSET_LIMIT_VIOLATED: 'Too many assets are configured.',
  EXPIRED: 'The license key has been expired for more than {expiryGracePeriodDays} day(s).',
  EXPIRED_GRACE_PERIOD: 'The license has expired please update your license as soon as possible, or you will loose access to Qmulus.',
  INVALID: 'The entered license key is invalid.',
  USER_LIMIT_VIOLATED: 'Too many users are configured.',
  OTHER: 'Unknown error while verifying the license.',
};

export default {
  enterLicense: 'Enter license key',
  contactSales: 'To obtain a new license, please get in contact with your Qmulus Sales representative.',
  ignore: 'Ignore',
  expiresSoon: {
    summary: 'The license key is about to expire',
    details: 'The license key will expire on {date}.',
  },
  details,
};
